(function(angular) {
	var STATE_NAME = 'app.cart.checkout.process.times';

	var DAY_IN_MS = 1000 * 60 * 60 * 24;

	angular.module('mobilezuz').config(['$stateProvider', function($stateProvider) {
		$stateProvider.state(STATE_NAME, {
			url: '/times',
			checkoutViewOriginalIndex: 0,
			checkoutViewIndex: 0,
			views: {
				'checkoutProcess': {
					templateUrl: 'views/checkout/process/times.html',
					controller: 'CheckoutTimesCtrl as checkoutTimesCtrl'
				}
			}
		});
	}]).controller('CheckoutTimesCtrl', [
		'$scope', '$rootScope', '$timeout', '$q', '$state', '$filter', 'Config', 'Retailer', 'User', 'SpDeliveryTimesService',
		'branchArea', 'Cart', 'Util', 'mDesign', 'SpProductTags', 'ShippingTermsPopup', 'SeniorCitizenVerificationDialog',
		'DELIVERY_TIMES_TYPES', 'DELIVERY_CHOICES', 'CART_LINE_TYPES', 'PRODUCT_TAG_TYPES', 'SP_SERVICES', 'Util', 'DataLayer','PRODUCT_TAG_ID','DELIVERY_MODE_TOGGLE','PermanentFilters',
		function($scope, $rootScope, $timeout, $q, $state, $filter, Config, Retailer, User, SpDeliveryTimesService,
				 branchArea, Cart, Util, mDesign, SpProductTags, ShippingTermsPopup, SeniorCitizenVerificationDialog,
				 DELIVERY_TIMES_TYPES, DELIVERY_CHOICES, CART_LINE_TYPES, PRODUCT_TAG_TYPES, SP_SERVICES, util, DataLayer, PRODUCT_TAG_ID, DELIVERY_MODE_TOGGLE, PermanentFilters) {
			var checkoutProcessCtrl = $scope.checkoutProcessCtrl,
				checkoutTimesCtrl = this,
				_translate = $filter('translate'),
				_listeners = [],
                _FILTERING_MODES = {
                    NONE: 'none',
                    CITY: 'city',
                    ZIP_CODE: 'zipCode',
                    STREET: 'street'
                };
			
			checkoutProcessCtrl.timesDetails = checkoutProcessCtrl.timesDetails || {};

			if (checkoutProcessCtrl.isAddressFirst && !checkoutProcessCtrl.addressDetails) {
				return checkoutProcessCtrl.goToState('app.cart.checkout.process.address', 500);
			}

			checkoutTimesCtrl.changeTimeChoice = changeTimeChoice;
			checkoutTimesCtrl.chooseDeliveryTime = chooseDeliveryTime;
			checkoutTimesCtrl.getDeliveryTimes = getDeliveryTimes;
			checkoutTimesCtrl.branch = Config.branch;
			checkoutProcessCtrl.nextView = nextView;
			checkoutProcessCtrl.previousView = previousView;
			checkoutProcessCtrl.validateView = validateView;
			checkoutTimesCtrl.changeAsap = changeAsap;
			checkoutTimesCtrl.onDisabledOptionSelected = onDisabledOptionSelected;
			checkoutTimesCtrl.onBranchAreaChange = onBranchAreaChange;
			checkoutTimesCtrl.isSpecialShown = isSpecialShown;
			checkoutTimesCtrl.onExpressOptionChange = onExpressOptionChange;
			checkoutTimesCtrl.showSeniorCitizen = showSeniorCitizen;
            checkoutTimesCtrl.isActiveMobileExpress = false;
			Config.waitForInit().then(function () {
                if (Config.retailer.settings) {
					checkoutTimesCtrl.isActiveMobileExpress = util.tryParseJson(Config.retailer.settings.mobileExpressDelivery) && util.tryParseJson(Config.retailer.settings.mobileExpressDelivery).isActive || false;
					var isSupportExpressDelivery = localStorage.getItem('mobileZuzAreaSupportedExpressDelivery') === 'true';
					if(checkoutTimesCtrl.isActiveMobileExpress && isSupportExpressDelivery) {
						_setDeliveryModeToggle();
					}

                }
            });
			Config.checkoutData.state = STATE_NAME;
			Config.checkoutData.timesDetails = checkoutProcessCtrl.timesDetails;

			ShippingTermsPopup.showWithRedirect('app.cart');

			_initializeTimeChoice();

			if (checkoutProcessCtrl.isDelivery) {
				_setIsSeniorCitizen();
			}

			function nextView() {
				checkoutProcessCtrl.addDeliveryProduct();
				if (!checkoutProcessCtrl.isAddressFirst) {
					return checkoutProcessCtrl.goToState('app.cart.checkout.process.address');
				}
				checkoutProcessCtrl.goToState('app.cart.checkout.process.' + (checkoutProcessCtrl.isPaymentLast() ? 'summary' : 'payment'));
			}
			function previousView() {
				if (!checkoutProcessCtrl.isAddressFirst) return;

				checkoutProcessCtrl.goToState('app.cart.checkout.process.address');
			}

			function chooseDeliveryTime(dTime) {
				checkoutTimesCtrl.collapseTimes = !checkoutTimesCtrl.collapseTimes;

				checkoutProcessCtrl.timesDetails.deliveryTime = dTime;
			}

			function _initializeTimeChoice() {
				checkoutProcessCtrl.timesDetails.branchArea = checkoutProcessCtrl.timesDetails.branchArea || branchArea;
				if (checkoutProcessCtrl.areas && checkoutProcessCtrl.areas.length && checkoutProcessCtrl.areas.length > 1) {
					_setBranchAreaFromAreasList();
				}

				onBranchAreaChange();
			}

			function _setDeliveryModeToggle() {
				var isExpressDelivery = checkoutProcessCtrl.timesDetails.branchArea.area.deliveryTypeId === SP_SERVICES.DELIVERY_TYPES.EXPRESS_DELIVERY;
                var productTagIds = isExpressDelivery ? [PRODUCT_TAG_ID.EXPRESS_DELIVERY] : [];
                var mode;
                
                if (isExpressDelivery) {
                    mode = DELIVERY_MODE_TOGGLE.EXPRESS_DELIVERY;
                } else {
                    mode = DELIVERY_MODE_TOGGLE.SCHEDULED_DELIVERY_PICKUP;
                }
                localStorage.setItem('mobileZuzModeToggle', mode);
                PermanentFilters.addProductTagsFilters(productTagIds, true);
            }
			function _setBranchAreaFromAreasList() {
				var currentAreaInList = checkoutProcessCtrl.areas.find(function(areaWrapper) {
					return checkoutProcessCtrl.timesDetails.branchArea === areaWrapper;
				});
				if (currentAreaInList) {
					return;
				}

				var listArea = checkoutProcessCtrl.areas.find(function(areaWrapper) {
					return checkoutProcessCtrl.timesDetails.branchArea.area.id === areaWrapper.area.id;
				});

				var days,
					withinHoursDeliveryTime,
					withinDaysDeliveryTime,
					expressDeliveryTime;
				if (checkoutProcessCtrl.timesDetails.deliveryChoice === DELIVERY_CHOICES.SHIPPING) {
					if (listArea.times[DELIVERY_CHOICES.SHIPPING]) {
						days = listArea.times[DELIVERY_CHOICES.SHIPPING];
					}
				} else {
					if (listArea.times[DELIVERY_CHOICES.LOCAL_DELIVERY][DELIVERY_TIMES_TYPES.REGULAR]) {
						days = listArea.times[DELIVERY_CHOICES.LOCAL_DELIVERY][DELIVERY_TIMES_TYPES.REGULAR];
					}
					if (listArea.times[DELIVERY_CHOICES.LOCAL_DELIVERY][DELIVERY_TIMES_TYPES.DELIVERY_WITHIN_HOURS]) {
						withinHoursDeliveryTime = listArea.times[DELIVERY_CHOICES.LOCAL_DELIVERY][DELIVERY_TIMES_TYPES.DELIVERY_WITHIN_HOURS];
					}
					if (listArea.times[DELIVERY_CHOICES.LOCAL_DELIVERY][DELIVERY_TIMES_TYPES.EXPRESS_DELIVERY]) {
						expressDeliveryTime = listArea.times[DELIVERY_CHOICES.LOCAL_DELIVERY][DELIVERY_TIMES_TYPES.EXPRESS_DELIVERY];
					}
					if (listArea.times[DELIVERY_CHOICES.LOCAL_DELIVERY][DELIVERY_TIMES_TYPES.DELIVERY_WITHIN_DAYS]) {
						withinDaysDeliveryTime = listArea.times[DELIVERY_CHOICES.LOCAL_DELIVERY][DELIVERY_TIMES_TYPES.DELIVERY_WITHIN_DAYS];
					}
				}

				var foundDeliveryDay,
					foundDeliveryTime;
				angular.forEach(days || [], function(day) {
					if (checkoutProcessCtrl.timesDetails.deliveryChoice === DELIVERY_CHOICES.SHIPPING) {
						if (checkoutProcessCtrl.timesDetails.deliveryDay && day.date === checkoutProcessCtrl.timesDetails.deliveryDay.date) {
							foundDeliveryDay = day;
						}
					} else if (checkoutProcessCtrl.timesDetails.deliveryTime) {
						if (day.isToday && withinHoursDeliveryTime && checkoutProcessCtrl.timesDetails.deliveryTime.id === withinHoursDeliveryTime.id) {
							foundDeliveryTime = withinHoursDeliveryTime;
							foundDeliveryDay = day;
							return;
						}
						
						if (day.isToday && expressDeliveryTime && checkoutProcessCtrl.timesDetails.deliveryTime.id === expressDeliveryTime.id) {
							foundDeliveryTime = expressDeliveryTime;
							foundDeliveryDay = day;
							return;
						}

						if (day.isToday && withinDaysDeliveryTime && checkoutProcessCtrl.timesDetails.deliveryTime.id === withinDaysDeliveryTime.id) {
							foundDeliveryTime = withinDaysDeliveryTime;
							foundDeliveryDay = day;
							return;
						}

						angular.forEach(day.times, function(deliveryTime) {
							if (deliveryTime.id === checkoutProcessCtrl.timesDetails.deliveryTime.id) {
								foundDeliveryTime = deliveryTime;
								foundDeliveryDay = day;
							}
						});
					}
				});

				checkoutProcessCtrl.timesDetails.branchArea = listArea;
				checkoutProcessCtrl.timesDetails.deliveryDay = foundDeliveryDay;
				checkoutProcessCtrl.timesDetails.deliveryTime = foundDeliveryTime;
			}

			function _setOrderForTimes() {
				var sortByKey = Config.retailer.twoHourLaw && checkoutProcessCtrl.isDelivery ? 'fromDisplay' : 'from';
				var availableSlotsCount = 0;
				var unavailableSlotsCount = 0;
				angular.forEach(checkoutTimesCtrl.timesSlots, function (date) {
					if (Array.isArray(date.times)) {
						date.times.sort(function (a, b) {
							return new Date(a[sortByKey]) - new Date(b[sortByKey]);
						});
						var enabledSlots = date.times.filter(function (time) {
							return time.isActive;
						});
						if(date.times.length > 0){
							unavailableSlotsCount += date.times.length - enabledSlots.length;
							availableSlotsCount += enabledSlots.length;
						}
						else{
							unavailableSlotsCount ++;
						}
					}
				});
				var filteringMode = _FILTERING_MODES.NONE;
				if(checkoutProcessCtrl.isAddressFilteringCityMode){
					filteringMode = _FILTERING_MODES.CITY;
				}
				else if(checkoutProcessCtrl.isAddressFilteringZipCodeMode){
					filteringMode = _FILTERING_MODES.ZIP_CODE;
				}
				else if(checkoutProcessCtrl.isAddressFilteringStreetMode){
					filteringMode = _FILTERING_MODES.STREET;
				}
				
				$rootScope.$emit(SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_DELIVERY_SLOT_STEP_VIEW, {
					selectedStoreId: checkoutProcessCtrl.timesDetails.branchArea.area.id,
					earlyDeliveryOptionShown: $rootScope.config.retailer.isAsapActive,
					deliveryTypeId: checkoutProcessCtrl.timesDetails.branchArea.area.deliveryTypeId,
					unavailableSlotsCount: unavailableSlotsCount,
					availableSlotsCount: availableSlotsCount,
					addressCompletedMethod: checkoutProcessCtrl.addressCompletedMethod,
					filteringMode: filteringMode,
				});
			}

			function onBranchAreaChange() {
				if (!checkoutProcessCtrl.timesDetails.branchArea || !checkoutProcessCtrl.timesDetails.branchArea.times ||
					!checkoutProcessCtrl.timesDetails.branchArea.times[DELIVERY_CHOICES.LOCAL_DELIVERY] &&
					!checkoutProcessCtrl.timesDetails.branchArea.times[DELIVERY_CHOICES.SHIPPING]) {
					checkoutTimesCtrl.timesSlots = SpDeliveryTimesService.timesObject()[DELIVERY_TIMES_TYPES.REGULAR];
					_setOrderForTimes();
					return;
				}

				if (checkoutProcessCtrl.timesDetails.branchArea.times[DELIVERY_CHOICES.LOCAL_DELIVERY] && checkoutProcessCtrl.timesDetails.branchArea.times[DELIVERY_CHOICES.SHIPPING]) {
					checkoutProcessCtrl.timesDetails.dualMode = true;
				}

				checkoutProcessCtrl.timesDetails.deliveryChoice = checkoutProcessCtrl.timesDetails.deliveryChoice || (checkoutProcessCtrl.timesDetails.branchArea.times[DELIVERY_CHOICES.LOCAL_DELIVERY] ? DELIVERY_CHOICES.LOCAL_DELIVERY : DELIVERY_CHOICES.SHIPPING);
				if (checkoutProcessCtrl.timesDetails.branchArea.times[checkoutProcessCtrl.timesDetails.deliveryChoice]) {
					changeTimeChoice();
				} else {
					checkoutTimesCtrl.timesSlots = SpDeliveryTimesService.timesObject()[DELIVERY_TIMES_TYPES.REGULAR];
					_setOrderForTimes();
				}
				Config.setBranchArea(checkoutProcessCtrl.timesDetails.branchArea.area.id, checkoutProcessCtrl.timesDetails.branchArea.area.name, true);
			}

			function isSpecialShown(special) {
				if (Config.showCouponsSpecials) {
					return true;
				}

				return !special.isCoupon;
			}

			function _setExpressTimeDisabled(expressTime) {
				var expressLimits = SpDeliveryTimesService.getExpressTimeProductTagLimits(
					Config.retailer.isExpressDeliveryByTag, Config.retailer.expressDeliveryProductsLimit);
				expressTime.disabled = !expressLimits.isEnabled || !expressLimits.isUnderQuantityLimit;

				expressTime.customData = expressTime.customData || {};
				expressTime.customData.exceededLimit = !expressLimits.isUnderQuantityLimit;
				expressTime.customData.hasNonExpressProducts = !expressLimits.isEnabled;
				expressTime.customData.productsLimit = Config.retailer.expressDeliveryProductsLimit;
			}

			function changeTimeChoice() {
				if (!checkoutProcessCtrl.timesDetails.branchArea.times[DELIVERY_CHOICES.SHIPPING] && !checkoutProcessCtrl.timesDetails.branchArea.times[DELIVERY_CHOICES.LOCAL_DELIVERY]) {
					return;
				}

				if (checkoutProcessCtrl.timesDetails.deliveryChoice === DELIVERY_CHOICES.SHIPPING) {
					checkoutTimesCtrl.timesSlots = checkoutProcessCtrl.timesDetails.branchArea.times[DELIVERY_CHOICES.SHIPPING];
					_setOrderForTimes();
					return;
				}

				SpDeliveryTimesService.isDeliveryWithinDaysOnly({
					deliveryTimesObj: checkoutProcessCtrl.timesDetails.branchArea.times[DELIVERY_CHOICES.LOCAL_DELIVERY],
					areaId: checkoutProcessCtrl.timesDetails.branchArea.area.id,
					retailerId: Config.retailer.id,
					isDeliveryWithinDaysByTag: Config.retailer.isDeliveryWithinDaysByTag
				}).then(function(isDeliveryWithinDaysOnly) {
					checkoutTimesCtrl.timesSlots = checkoutProcessCtrl.timesDetails.branchArea.times[DELIVERY_CHOICES.LOCAL_DELIVERY][DELIVERY_TIMES_TYPES.REGULAR];
					_setOrderForTimes();

					checkoutTimesCtrl.isDeliveryWithinDaysOnly = isDeliveryWithinDaysOnly;
					checkoutTimesCtrl.timesSlots[0].times = checkoutTimesCtrl.timesSlots[0].times || [];

					var withinDaysDelivery = checkoutProcessCtrl.timesDetails.branchArea.times[DELIVERY_CHOICES.LOCAL_DELIVERY][DELIVERY_TIMES_TYPES.DELIVERY_WITHIN_DAYS];
					if (withinDaysDelivery) {
						var listWithinDaysDelivery = checkoutTimesCtrl.timesSlots[0].times.find(function(time) {
							return time.type === DELIVERY_TIMES_TYPES.DELIVERY_WITHIN_DAYS;
						});
						if (!listWithinDaysDelivery) {
							checkoutTimesCtrl.timesSlots[0].times.unshift(withinDaysDelivery);
						}

						if (checkoutTimesCtrl.isDeliveryWithinDaysOnly) {
							checkoutProcessCtrl.timesDetails.deliveryDay = checkoutTimesCtrl.timesSlots[0];
							checkoutProcessCtrl.timesDetails.deliveryTime = listWithinDaysDelivery || withinDaysDelivery;
						}
					}
					
					var withinHoursDelivery = checkoutProcessCtrl.timesDetails.branchArea.times[DELIVERY_CHOICES.LOCAL_DELIVERY][DELIVERY_TIMES_TYPES.DELIVERY_WITHIN_HOURS];
					var expressDelivery = checkoutProcessCtrl.timesDetails.branchArea.times[DELIVERY_CHOICES.LOCAL_DELIVERY][DELIVERY_TIMES_TYPES.EXPRESS_DELIVERY];
					if (checkoutTimesCtrl.isActiveMobileExpress) {
						if (expressDelivery) {
							var listExpressDelivery = checkoutTimesCtrl.timesSlots[0].times.find(function (time) {
								return time.type === DELIVERY_TIMES_TYPES.EXPRESS_DELIVERY;
							});
							if (!listExpressDelivery) {
								_setExpressTimeDisabled(expressDelivery);
								checkoutTimesCtrl.timesSlots[0].times.unshift(expressDelivery);
							} else {
								_setExpressTimeDisabled(listExpressDelivery);
							}
						}
					} else {
						if (withinHoursDelivery) {
							var listWithinHoursDelivery = checkoutTimesCtrl.timesSlots[0].times.find(function (time) {
								return time.type === DELIVERY_TIMES_TYPES.DELIVERY_WITHIN_HOURS;
							});
							if (!listWithinHoursDelivery) {
								_setExpressTimeDisabled(withinHoursDelivery);
								checkoutTimesCtrl.timesSlots[0].times.unshift(withinHoursDelivery);
							} else {
								_setExpressTimeDisabled(listWithinHoursDelivery);
							}
						}
					}
				});
			}

			function getDeliveryTimes(options) {
				options = options || {};
				return Retailer.getRetailerSettings()
					.then(function(retailer) {
						if (options.scroll) {
							if (checkoutProcessCtrl.checkingAddressInProgress) {
								return $q.reject();
							}

							if (retailer.deliveryCustomerDisplayDays === 0 || retailer.deliveryCustomerDisplayDays === null) {
								return $q.reject();
							}

							var today = SpDeliveryTimesService.now();
							today.setUTCHours(0, 0, 0, 0);

							if (checkoutTimesCtrl.timesSlots && checkoutTimesCtrl.timesSlots.length) {
								options.startDate = new Date(new Date(checkoutTimesCtrl.timesSlots[checkoutTimesCtrl.timesSlots.length - 1].date).getTime() + DAY_IN_MS);
							} else {
								options.startDate = new Date(today);
							}

							if (options.startDate >= (today.getTime() + (DAY_IN_MS * retailer.deliveryCustomerDisplayDays))) {
								return $q.reject();
							}
						}

						return checkoutProcessCtrl.getDeliveryTimes(undefined, options)
							.then(function(response) {
								var times = util.getDataByPath(response, 'area.timesObject.times');
								if (response.area && angular.isArray(response.area.areas) && response.area.areas.length > 1) {
									var selectedPickupArea;
									angular.forEach(response.area.areas, function(area) {
										if (area.id === checkoutProcessCtrl.timesDetails.branchArea.area.id) {
											selectedPickupArea = area;
										}
									});
									if (selectedPickupArea) {
										times = selectedPickupArea.times;
									}
								}
								Array.prototype.push.apply(checkoutTimesCtrl.timesSlots, times.localDelivery[DELIVERY_TIMES_TYPES.REGULAR]);
							});
					});
			}

			function validateView() {
				if (checkoutProcessCtrl.timesDetails.branchArea.area.deliveryProviderId === SP_SERVICES.DELIVERY_PROVIDERS.MANUAL &&
					checkoutProcessCtrl.timesDetails.branchArea.area.providerExtraData.showShippingInputAtCheckout &&
					checkoutProcessCtrl.timesDetails.branchArea.area.providerExtraData.isShippingInputRequired &&
					!checkoutProcessCtrl.timesDetails.shippingCarrierCode) {
					return {
						msg: _translate('required error')
							.replace('{{name}}', checkoutProcessCtrl.timesDetails.branchArea.area.providerExtraData.shippingInputTitle)
					};
				}

				if (!!checkoutProcessCtrl.timesDetails.deliveryTime || checkoutProcessCtrl.timesDetails.deliveryChoice === DELIVERY_CHOICES.SHIPPING) {
					return;
				}

				return { msg: 'Sorry, no available ' + (checkoutProcessCtrl.isDelivery ? 'delivery' : 'pickup') + ' time slots' };
			}

			function changeAsap(asap) {
				checkoutProcessCtrl.timesDetails.asap = asap;
			}

			function onDisabledOptionSelected(time) {
				if (checkoutTimesCtrl.isActiveMobileExpress) {
					if (time.type !== DELIVERY_TIMES_TYPES.EXPRESS_DELIVERY) {
						return;
					}
				} else {
					if (time.type !== DELIVERY_TIMES_TYPES.DELIVERY_WITHIN_HOURS) {
						return;
					}
				}

				if (time.customData.exceededLimit) {
					return _showExpressErrorAlert('' +
						'{{\'Express delivery is limited to\' | translate}} ' +
						time.customData.productsLimit +
						' {{\'items. To enable this service, remove items from your cart\' | translate}}.'
					);
				}

				if (time.customData.hasNonExpressProducts) {
					return _showExpressErrorAlert('{{\'This service is available for Express items only. Removing Non Express items from your cart will enable using this option\' | translate}}.');
				}
			}

			function _showExpressErrorAlert(message) {
				return mDesign.dialog({
					focusOnOpen: false,
					clickOutsideToClose: true,
					template: '' +
						'<md-dialog-content class="express-products-error-dialog">' +
						'<svg focusable="false" class="product-express-delivery-icon">' +
						'<use xlink:href="#sp-express-delivery"></use>' +
						'</svg>' +
						'<div class="express-products-error-dialog-message">' + message + '</div>' +
						'</md-dialog-content>' +
						'<md-dialog-actions>' +
						'<md-button class="md-primary" ng-click="hide()">{{\'OK\' | translate}}</md-button>' +
						'</md-dialog-actions>',
					controller: ['$scope', function($scope) {
						$scope.hide = mDesign.hide;
					}]
				});
			}

			function showSeniorCitizen() {
				return SeniorCitizenVerificationDialog.show().then(function() {
					return _setIsSeniorCitizen();
				}).then(function() {
					if (!checkoutTimesCtrl.isSeniorCitizen) {
						return;
					}

					return checkoutProcessCtrl.getDeliveryTimes(undefined, {
						externalPlaceId: checkoutProcessCtrl.addressDetails.externalPlaceId,
						geoCoordinates: checkoutProcessCtrl.addressDetails.geoCoordinates
					}).then(function() {
						_initializeTimeChoice();
					});
				});
			}

			function _setIsSeniorCitizen() {
				return User.getUserSettings().then(function(userData) {
					checkoutTimesCtrl.isSeniorCitizen = userData.isSeniorCitizen;
				});
			}

			function _sendDataLayerEvent() {
				var cartLineProducts = [];
				angular.forEach(Cart.lines, function (line) {
					if(line && line.product && line.product.id) {
						line.product.quantity = line.quantity;
						cartLineProducts.push(line.product);
					}
				});
				DataLayer.push(DataLayer.EVENTS.CHECKOUT, {products: cartLineProducts, data: {step: 3, option: 'time slot'}});
			}

			function onExpressOptionChange(isShown) {
				checkoutTimesCtrl.isExpressOptionShown = isShown || false;
			}

			_listeners.push($rootScope.$on('cart.update.complete', _sendDataLayerEvent));

			// Watch for changes in deliveryTime
			_listeners.push($scope.$watch('checkoutProcessCtrl.timesDetails.deliveryTime', function(newValue, oldValue) {
				if (newValue !== oldValue) {
					
					var deliveryPrice = Util.getDataByPath(newValue, 'deliveryProduct.branch.regularPrice') || 0;
					var slotAvailable = Util.getDataByPath(newValue, 'isActive');
					var object = {
						selectedStoreId: Util.getDataByPath(checkoutProcessCtrl, 'timesDetails.branchArea.area.id'),
						slotDate: Util.getDataByPath(checkoutProcessCtrl, 'timesDetails.deliveryDay.date'),
						selectedTimeWindow: slotAvailable? Util.getDataByPath(newValue, 'newFrom') + ' - ' + Util.getDataByPath(newValue, 'newTo') : '',
						slotType: Util.getDataByPath(newValue, 'type'),
						deliveryFee: deliveryPrice,
						isSlotAvailable: slotAvailable,
						earlyDeliveryPreferenceSet: Util.getDataByPath(checkoutProcessCtrl, 'timesDetails.asap') || false
					};
					$rootScope.$emit($rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_DELIVERY_SLOT_CHANGED, object);
				}
			}, true));

			util.destroyListeners($scope, _listeners);

			Cart.save();
		}]);
})(angular);
